export const templates = [
  {
    type: 1,
    regexp: /^пресс(\(\d сери.\))?(\(\dх\d+ раз.?\))?$/i,
  },
  {
    type: 2,
    regexp: /^спина(\(\d сери.\))?(\(\dх\d+ раз.?\))?$/i,
  },
  {
    type: 3,
    regexp: /^руки(\(\d сери.\))?(\(\dх\d+ раз.? и \d+-\d+ раз.?\))?$/i,
  },
  {
    type: 4,
    regexp: /^ноги(\(без веса\))?(\(\d сери.\))?$/i,
  },
  {
    type: 5,
    regexp: /^мфр$/i,
  },
  {
    type: 6,
    regexp: /^баня(\(при необходимости\))?$/i,
  },
  {
    type: 7,
    regexp: /^массаж(\(при необходимости\))?$/i,
  },
  {
    type: 8,
    regexp: /^упражнения$/i,
  },
  {
    type: 9,
    regexp: /^\d+ м-б\.у\.\(через (ходьбу обратно)|(п\.о\.)\)$/,
  },
  {
    type: 10,
    regexp:
      /^(\d+х)?\d+ м-многоскоки (по прямой)?(в гору)?(\(через (ходьбу обратно)?(\d+ м\(до 22\))?\))?$/,
  },
  {
    type: 11,
    regexp:
      /^\d+х50 м-(ускорения|с\.у\.)(\(через ходьбу обратно\))?(\(через 50 м\(до 22\)\))?(\(растянуть до старта(,закончить за 7-8 минут до (старта|него))?\))?$/,
  },
  {
    type: 12,
    regexp: /^\d+х100 м-с\.у\.( под тягун)?\(через 100 м\(до 22\)\)$/,
  },
  {
    type: 13,
    regexp:
      /^(\d+х)?\(\d+ раз-выпады в гору\+\d+ м-олень в гору\(\d+ м-левая\+\d+ м-правая\)\+\d+ м-(очень спокойная)?(активная)? трусца\+\d+ м-с\.у\. в гору силовым бегом\+\d+ раз-выпрыгивания с полуприседов вверх на месте\+\d+ м-(очень спокойная)?(активная)? трусца\+\d+ раз-выпады в гору\+\d+ м-олень в гору\(\d+ м-левая\+\d+ м-правая\)\+\d+ м-(очень спокойная)?(активная)? трусца\+\d+ м-с\.у\. в гору силовым бегом\+\d+ раз-выпрыгивания с полуприседов вверх на месте\+\d+ м-(очень спокойная)?(активная)? трусца\+\d+ раз-боковые прыжки в гору\+\d+ раз-лягушка с полуприседов в гору\+\d+ м-бег в гору с высоким подниманием бёдер\+\d+ м-(очень спокойная)?(активная)? трусца\+\d+ м-прыжки в гору на стопах\+\d+ м-(очень спокойная)?(активная)? трусца\+\d+ м-частый бег в гору\+\d+ м-(очень спокойная)?(активная)? трусца\+\d+ м-с\.у\. в гору\)(\(через \d+ м\(до 22\)\))?$/,
  },
  {
    type: 14,
    regexp:
      /^(\d+х)?\d+ к?м\(\d+ раз-прыжки в выпадах на месте со сменой ног в воздухе\+\d+ м-многоскоки в гору\+\d+ м-с\.у\. в гору силовым бегом\+(\d+ раз-скачки на месте\+)?(\d+ раз-выпрыгивания с полуприседов вверх на месте\+)?\d+ м-(очень спокойная)?(активная)? трусца\+\d+ раз-прыжки в выпадах на месте со сменой ног в воздухе\+\d+ м-многоскоки в гору\+\d+ м-с\.у\. в гору\+(\d+ раз-скачки на месте\+)?(\d+ раз-выпрыгивания с полуприседов вверх на месте\+)?\d+ м-(очень спокойная)?(активная)? трусца\+\d+ раз-прыжки в выпадах на месте со сменой ног в воздухе\+\d+ м-прыжки на одной ноге в гору\(\d+(,\d+)? м-на левой,\d+(,\d+)? м-на правой\)\+\d+ м-многоскоки в гору\+\d+ м-с\.у\. в гору\)(\(через \d+ м\(до 22\)\))?$/,
  },
  {
    type: 15,
    regexp: /^анализ крови$/i,
  },
  {
    type: 16,
    regexp: /^п\.о\.$/i,
  },
  {
    type: 17,
    regexp: /^(\d+х)?\d+ раз(а)?-прыжки на носках на ступеньку и обратно$/,
  },
  {
    type: 18,
    regexp: /^\d+(,\d)? (мин\.)?(сек.)? отдыха(\(в конце \d+ м\(до 22\)\))?$/,
  },
  {
    type: 19,
    regexp: /^-$/,
  },
  {
    type: 20,
    regexp:
      /^(\d+х)?\(\d+ раз-выпады в гору\+\d+ м-олень в гору\(\d+ м-левая\+\d+ м-правая\)\+\d+ м-с\.у\. в гору силовым бегом\+\d+ раз-выпрыгивания с полуприседов вверх на месте\+\d+ м-(очень спокойная)?(активная)? трусца\+\d+ раз-выпады в гору\+\d+ м-олень в гору\(\d+ м-левая\+\d+ м-правая\)\+\d+ м-с\.у\. в гору силовым бегом\+\d+ раз-выпрыгивания с полуприседов вверх на месте\+\d+ м-(очень спокойная)?(активная)? трусца\+\d+ раз-боковые прыжки в гору\+\d+ раз-лягушка с полуприседов в гору\+\d+ м-бег в гору с высоким подниманием бёдер\+\d+ м-прыжки в гору на стопах\+\d+ м-частый бег в гору\+\d+ м-с\.у\. в гору\)(\(через \d+ м\(до 22\)\))?/,
  },
  {
    type: 21,
    regexp:
      /^\d+х\(\d+ раз-прыжки в выпадах на месте со сменой ног в воздухе\+\d+ м-прыжки на одной ноге в гору\(\d+(,\d+)? м-на левой,\d+(,\d+)? м-на правой\)\+\d+ м-многоскоки в гору\)\(через \d+ м\(до 22\)\)/,
  },
  {
    type: 22,
    regexp:
      /^(\d+х)?\d+ м\(\d+ м-многоскоки в гору\+\d+ м-с\.у\. в гору силовым бегом\)\(через \d+ м\(до 22\)\)/,
    resultsPerSeries: 0,
  },
  {
    type: 23,
    regexp: /^(\d+х)?\d+ м-многоскоки в гору\(через \d+ м\(до 22\)\)/,
    resultsPerSeries: 0,
  },
  {
    type: 24,
    regexp: /^стопы|апу|плиометрика/i,
  },
  {
    type: 25,
    regexp: /^асмр/i,
  },
  {
    type: 26,
    regexp: /^50 м-((близко к max)|(ускорение))/,
  },
  {
    type: 27,
    regexp: /^500 м\(400 м\(до 27\)\+100 м-с\.у\.\)\(пульс\)/,
  },
  {
    type: 28,
    regexp: /^1 км\(500 м\(до 25\)\+400 м\(до 27\)\+100 м-с\.у\.\)\(пульс\)/,
  },
  {
    type: 29,
    regexp: /^\d+х\d+ мин\.\(пано\)\(через \d+ сек\. отдыха\)/,
  },
  {
    type: 30,
    regexp: /^100 м-с\.у\./,
  },
  {
    type: 31,
    regexp: /^50 м-б\.у\. в гору\(через 50 м\(до 22\)\)/,
  },
  {
    type: 32,
    regexp:
      /^50 м(\(до 22\))|(-прыжки на стопах в гору)|(-частый бег в гору)|(-прыжки на одной ноге в гору\(25 м-на левой,25 м-на правой\))/,
  },
];
// 2х(2х1 км(200 м(до 27)(50,5)+200 м-с.у.(43-45)+600 м(до 27)(2:31,5))(4:05)(через 150 м(до 22)(1:00-1:10)))(через 150 м(до 22)(1:00-1:10))
